import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d386125e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "result-picture-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info-small" }, " Tire uma foto do dispositivo, mostrando nitidamente as linhas de resultado do autoteste. Essa foto aparecerá no seu cartão de resultado. ", -1))
const _hoisted_3 = {
  key: 0,
  class: "step-info-small ios-info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Importante:", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" caso você use iPhone e a câmera não estiver funcionando, é necessário ir em ajustes, selecionar o seu navegador, marcar a opção de câmera e recarregar a página. ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "error-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Foto do dispositivo obrigatória.", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_upload_picture = _resolveComponent("upload-picture")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_example_test_modal = _resolveComponent("example-test-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "5",
      stepTitle: _ctx.StepContent.title,
      nextButtonActive: _ctx.canJumpNext,
      onNextStep: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        (_ctx.isIOSDevice())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true),
        _createVNode(_component_alert_box, {
          class: "px-3 mt-8",
          info: "",
          stepContent: _ctx.StepContent,
          onClick: _ctx.showInfoModal
        }, null, 8, ["stepContent", "onClick"]),
        _createVNode(_component_upload_picture, { onImageChanged: _ctx.imageChanged }, null, 8, ["onImageChanged"]),
        _withDirectives(_createElementVNode("div", _hoisted_7, _hoisted_9, 512), [
          [_vShow, _ctx.hasError]
        ])
      ]),
      _: 1
    }, 8, ["stepTitle", "nextButtonActive"]),
    _createVNode(_component_example_test_modal, { ref: "info-modal" }, null, 512)
  ]))
}